export default "__VITE_ASSET__XpLYbaQ4__"